















import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { FolderPostCSS } from "@/services/posts/postTypes/folder";

    @Component
export default class FolderStyle extends Vue {
        @Prop() private itemStyle!: Style;

        // computed
        get model(): FolderPostCSS {
            return this.itemStyle.css
                ? (this.itemStyle.css as FolderPostCSS)
                : ({} as FolderPostCSS);
        }
}
